module.exports = __webpack_public_path__ + "static/media/mirror-example-5.1f29db26.png";